module.exports = __webpack_public_path__ + "img/home_cards.bb53e572.png";